import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getVisibleLocations, getIsLoading, getIsSaving } from 'locations/selectors';
import { getPermissions } from 'auth/selectors';
import * as Locations from 'locations/components';
import LocationsTreeHandlers from 'locations/containers/LocationsTreeHandlers';

class LocationsTreeContainer extends Component {
  render() {
    return (
      <LocationsTreeHandlers
        render={({ handleAddLocation, handleRemoveLocation, handleValueChange, handleSubmit }) => (
          <Locations.TreeView
            handleAddLocation={handleAddLocation}
            handleRemoveLocation={handleRemoveLocation}
            handleSubmit={handleSubmit}
            handleValueChange={handleValueChange}
            isLoading={this.props.isLoading}
            isSaving={this.props.isSaving}
            locations={this.props.locations}
            permissions={this.props.permissions}
          />
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  locations: getVisibleLocations(state),
  isLoading: getIsLoading(state),
  isSaving: getIsSaving(state),
  permissions: getPermissions(state),
});

export default connect(mapStateToProps, null)(LocationsTreeContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/locations/containers/LocationsTreeContainer.js